import type { Model } from '@patsnap/tahiti-core';
import type { SpecificationConfirmDisclosureState } from '../types/specification-confirm-disclosure';

export const SpecificationConfirmDisclosureModel = Symbol.for('SpecificationConfirmDisclosureModel');

export interface SpecificationConfirmDisclosureModel extends Model<SpecificationConfirmDisclosureState> {}
